import {firstValueFrom} from 'rxjs';
/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {StateDeclarationBuilder, AdnRouterHelperApi} from '../../routing/state-utils';
import {stateTitleView} from '../../common/directives/html/state-title.component';
import {ReferenceDataPageComponent} from './reference-data-page.component';
import {NetworkApiService} from '../network/network-api.service';
import {NetworkProfileApiService} from '../../../components/session/network-profile-api.service';



export function referenceDataStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  const states = new StateDeclarationBuilder();
states.add('app.adm.reference-data', {
          url: '/reference-data',
          resolve: {
            ResourceFactory: function() {
              return adnRouterHelper.services.service(NetworkApiService);
            },
            network: function() {
              const LocalNetworkProfile = adnRouterHelper.services.localNetworkProfile();

              return firstValueFrom(adnRouterHelper.services.service(NetworkApiService).get(LocalNetworkProfile.getNetworkId()));
            },
            networkProfile: function() {
              const LocalNetworkProfile = adnRouterHelper.services.localNetworkProfile();

              return firstValueFrom(adnRouterHelper.services.service(NetworkProfileApiService).get(LocalNetworkProfile.getNetworkId()));
            }
          },
          views: {
            'content@app': {
              component: ReferenceDataPageComponent
            },
            'title@app': stateTitleView()
          },
          data: {
            title: "Reference Data"
          }
        });
  return states.build();
}